import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "edit-capability-container"
};
const _hoisted_2 = {
  key: 0,
  class: "operator-container"
};
const _hoisted_3 = {
  key: 1,
  class: "operator-container"
};
import { ref, onMounted, computed } from 'vue';
import { ElButton, ElInput, ElMessage, ElOption, ElRow, ElSelect, ElSwitch } from 'element-plus';
import { request } from '@/manager/net_manager';
import store from "@/store";
export default {
  __name: 'CapabilityEditCard',
  props: {
    capability: {
      type: Object,
      required: true
    }
  },
  emits: ['close', 'reload'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // refs

    const message = ref(null);
    const updatesForm = ref({
      name: '',
      desc: '',
      base_value: '',
      explain: '',
      type: null,
      extraordinary: false
    }); // computed

    const worldOutlook = computed(() => store.state.world_outlook);
    const capabilityTypes = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.capability_types ?? null;
    }); // functions

    const removeCapability = () => {
      if (message.value) {
        message.value.close();
      }

      request('capabilities/remove/', {
        'capability_id': props.capability.capability_id
      }, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        message.value = ElMessage.success({
          message: '能力已清除',
          duration: 1500
        });
        emits('reload');
        emits('close');
      });
    };

    const createCapability = () => {
      if (message.value) {
        message.value.close();
      }

      request('capabilities/create/', updatesForm.value, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        message.value = ElMessage.success({
          message: '能力已创建',
          duration: 1500
        });
        emits('reload');
        emits('close');
      });
    };

    const updateCapability = () => {
      if (message.value) {
        message.value.close();
      }

      request('capabilities/update/', {
        'updates': updatesForm.value
      }, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        message.value = ElMessage.success({
          message: '能力已调整',
          duration: 1500
        });
        emits('reload');
        emits('close');
      });
    }; // lifecycle


    onMounted(() => {
      if (props.capability && props.capability.capability_id) {
        const {
          type,
          ...buffer
        } = props.capability;
        updatesForm.value = buffer;
        updatesForm.value.type = type?.capability_type_id;
      }

      if (!capabilityTypes.value) {
        store.dispatch('get_capability_types');
      }
    });
    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ElRow), {
        style: {
          "gap": "16px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "能力名",
          "label-position": "top"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElInput), {
            modelValue: updatesForm.value.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => updatesForm.value.name = $event),
            maxlength: "16",
            placeholder: "能力名",
            round: "",
            type: "text",
            clearable: "",
            "show-word-limit": ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "展示名",
          "label-position": "top"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElInput), {
            modelValue: updatesForm.value.desc,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => updatesForm.value.desc = $event),
            maxlength: "16",
            placeholder: "展示名",
            round: "",
            type: "text",
            clearable: "",
            "show-word-limit": ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), capabilityTypes.value ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: "能力类别",
          "label-position": "top"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElSelect), {
            modelValue: updatesForm.value.type,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => updatesForm.value.type = $event),
            "show-arrow": false,
            placeholder: "能力类别",
            "popper-class": "commonPopper",
            class: _normalizeClass(updatesForm.value.type ? 'selected-selector' : '')
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(capabilityTypes.value, (item, index) => {
              return _openBlock(), _createBlock(_unref(ElOption), {
                key: index,
                label: item['desc'],
                value: item['capability_type_id']
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "class"])]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_unref(ElRow), null, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "能力基本描述",
          "label-position": "top",
          class: "full-row"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElInput), {
            modelValue: updatesForm.value.explain,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => updatesForm.value.explain = $event),
            type: "textarea",
            clearable: "",
            "show-word-limit": "",
            round: "",
            placeholder: "基本描述",
            maxlength: "120"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        style: {
          "gap": "16px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "基础数值/基础数值描述",
          "label-position": "top"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElInput), {
            modelValue: updatesForm.value.base_value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => updatesForm.value.base_value = $event),
            maxlength: "12",
            placeholder: "基础值",
            round: "",
            type: "text",
            clearable: "",
            "show-word-limit": ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "超凡性质",
          "label-position": "top"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElSwitch), {
            modelValue: updatesForm.value.extraordinary,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => updatesForm.value.extraordinary = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), props.capability && props.capability.capability_id ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_unref(ElButton), {
        class: "remove-capability",
        onClick: removeCapability
      }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" 删除能力 ", -1)]))]),
        _: 1
      }), _createVNode(_unref(ElButton), {
        onClick: updateCapability
      }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" 提交变更 ", -1)]))]),
        _: 1
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_unref(ElButton), {
        onClick: createCapability
      }, {
        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode(" 提交创建 ", -1)]))]),
        _: 1
      })]))]);
    };
  }

};